  import {
  Container,
  Divider,
  Grid,
  Header,
  Segment,
} from "semantic-ui-react";
import LetsikringVedKritiskSygdomImg from "../../images/letsikringvedkritisksygdom.jpg";
import LetsikringAfIndtagtVedPensionImg from "../../images/letsikringafindtaegtvedpension.jpg";
import LetsikringAfBarnVedDoed from "../../images/letsikringafbarnveddoed.jpg";
import LetsikringVedDoed from "../../images/letsikringveddoed.jpg";
import ImageLink from "../common/ImageLink";
import appRoutes from "../../routes/appRoutes";
import AutoAccordion from "../common/AutoAccordion";

const LetsikringAfHelbred = (props) => (
  <div>
    <Header as="h2" textAlign="center">
      Letsikring af helbred
    </Header>
    <Divider hidden />
    <Container text>
      {/*<Container text style={{textAlign: "center"}}>*/}
      {/*        <Image src={LetsikringAfHelbredImg} style={{width:'auto'}}/>*/}
      {/*</Container>*/}
      <Divider hidden />
      <p>
        Med en Letsikring af helbred får du adgang til hurtig undersøgelse og
        behandling - typisk inden for 1-10 hverdage - hvis du får smerter,
        bliver syg eller kommer ud for en skade.
      </p>
      <p>
        Du kan oprette en Letsikring af helbred, hvis du er mellem 18 og 67 år,
        og du har folkeregisteradresse i Danmark. Du har mulighed for at
        forsikre dine og din ægtefælles/samlevers børn, frem til de fylder 24
        år.
      </p>
      <p>
        Har du allerede en Letsikring af helbred og vil gøre brug af den? Ring
        på 7080 5500, eller gå ind på{" "}
        <a href="/forkunder/brugdinforsikring">brug din forsikring</a>.
      </p>
      <p>
        Har du ikke forsikringen, men ønsker at høre nærmere? Kontakt et{" "}
        <a href="/blivkunde">pengeinstitut i Letpension-samarbejdet</a>.
      </p>
      <h4>Hvad dækker Letsikring af helbred?</h4>
      <ul>
        <li>
          Udgifter til forundersøgelser, behandlinger og efterkontrol på
          privathospitaler, privatklinikker eller hos speciallæger
        </li>
        <li>Fysioterapeut, osteopat eller kiropraktor</li>
        <li>Akupunktur og zoneterapi </li>
        <li>Behandling hos fodterapeut</li>
        <li>Kroniske lidelser i bevægeapparatet</li>
        <li>Diætist</li>
        <li>Psykolog</li>
        <li>Behandling hos en psykiater</li>
        <li>Afvænning af misbrug af alkohol, medicin eller andre rusmidler</li>
        <li>Behandling af ludomani</li>
        <li>Genoptræning</li>
        <li>Rekreationsophold</li>
        <li>Receptpligtig medicin efter dækningsberettiget behandling</li>
        <li>Midlertidig hjemmehjælp og hjemmesygeplejerske</li>
        <li>
          Second opinion ved usikkerhed om diagnose eller fremtidig behandling.
        </li>
      </ul>
      <p>
        Er der krav om lægehenvisning? Ja, på nær psykolog i forbindelse med
        symptomer på stress eller behandling hos en osteopat og kiropraktor. PFA
        skal dog altid godkende behandling, inden den kan igangsættes.
      </p>
      <p>
        Du kan se nærmere betingelser for dækning i forsikringsbetingelserne.
      </p>
      <Divider hidden />
      <Segment basic style={{ backgroundColor: "#f6f0e7", color: "black" }}>
        <p>
          <b>
            Du kan også få Online Sundhedshjælp – uanset om du er hjemme, på
            arbejde eller på ferie
          </b>
        </p>
        <p>
          Du har adgang til Online Sundhedshjælp med en Letsikring af helbred.
        </p>
        <p>
          Brug Online Sundhedshjælp, uanset om du er hjemme, på arbejde eller på
          ferie.
        </p>
        <ul>
          <li>
            Få online hjælp hos læge, fysioterapeut, psykolog, familierådgiver
            og coach.
          </li>
          <li>Du kan normalt få tid indenfor 24 timer.</li>
          <li>Du kan også få hjælp om aftenen og i weekenden.</li>
          <li>
            Du behøver ingen lægehenvisning eller kontakt til PFA forinden, når
            du bruger Online Sundhedshjælp.{" "}
          </li>
          <li>Book tid direkte og hurtigt.</li>
        </ul>
        <p>
          Læs mere, og book Online Sundhedshjælp på{" "}
          <a
            href="https://www.letpension.dk/onlinesundhedshjaelp"
            target="_blank"
            rel="noreferrer"
          >
            www.letpension.dk/onlinesundhedshjaelp
          </a>
          .
        </p>
      </Segment>
      <Divider section hidden />
      <AutoAccordion activeIndex={-1}>
        <AutoAccordion.Item title="Hvad dækker Letsikring af helbred fx ikke?">
          <ul>
            <li>Kosmetiske operationer, pandeløft, hængende øjenlåg</li>
            <li>Briller, kontaktlinser, høreapparater eller tandbehandling</li>
            <li>Akutbehandlinger (fx vagtlæge eller skadestuesituationer)</li>
            <li>Behandling af barnløshed</li>
            <li>Behandling af sygdomme opstået på grund af epidemier</li>
            <li>Alternativ behandling.</li>
          </ul>
          <p>
            Bemærk, forsikringen dækker ikke de første 6 måneder for sygdomme,
            som er opstået, før Letsikringen blev oprettet, eller sygdomme, der
            er opstået som følge heraf. Du kan se nærmere betingelser for
            dækning i forsikringsbetingelserne.
          </p>
        </AutoAccordion.Item>
      </AutoAccordion>
    </Container>
    <Divider section hidden />

    <Grid centered stackable columns={2}>
      <Grid.Row>
        <ImageLink
          imageSrc={LetsikringVedKritiskSygdomImg}
          text="Letsikring ved kritisk sygdom"
          link={appRoutes.LETSIKRING_VED_KRITISK_SYGDOM}
        />
        <ImageLink
          imageSrc={LetsikringAfIndtagtVedPensionImg}
          text="Letsikring af indtægt ved pension"
          link={appRoutes.LETSIKRING_AF_INDTAEGT_VED_PENSION}
        />
      </Grid.Row>
      <Grid.Row>
        <ImageLink
          imageSrc={LetsikringAfBarnVedDoed}
          text="Letsikring af barn"
          link={appRoutes.LETSIKRING_AF_BARN_VED_DOED}
        />
        <ImageLink
          imageSrc={LetsikringVedDoed}
          text="Letsikring ved død"
          link={appRoutes.LETSIKRING_VED_DOED}
        />
      </Grid.Row>
    </Grid>
  </div>
);

export default LetsikringAfHelbred;
